import { BidProps } from "@/interfaces/bid_types"
import { z } from "zod"
import { BidFormSchema } from "./DefaultSchema"

export function ImportFormProps({formProps}: {formProps: BidProps}) {
    if (!formProps) return {}
    return {
        bid_id: formProps.bid_id,
        bid_name: formProps.bid_name,
        start_date: formProps.start_date || new Date().toISOString().split('T')[0],
        end_date: formProps.end_date ,
        description: formProps.description ?? "",
        status: formProps.status ? {
            value: formProps.status,
            label: formProps.status,
        } : {
            value: "Active",
            label: "Active",
        },
        category: formProps.category ? {
            value: formProps.category,
            label: formProps.category,
        } : undefined,
        template: formProps.template ? {
            value: formProps.template,
            label: formProps.template,
        } : {
            value: "Default",
            label: "Default",
        },
        folder_location: formProps.folder_location ?? "",
        isDeadline: formProps.isDeadline ?? false,
        no_date_due: formProps.no_date_due ?? false,
        manager: formProps.manager ? {
            value: formProps.manager.email,
            label: formProps.manager.name,
        } : undefined,
        city: formProps.city ? {
            value: formProps.city,
            label: formProps.city
        } : undefined,
    } as z.infer<typeof BidFormSchema>
}